import { Box, Divider, useMediaQuery } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

LogoCarousel.propTypes = {
  loghi : PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  )
}
export default function LogoCarousel({loghi = []}) {
  const isDesktop = useMediaQuery('(min-width:768px)');
  return (
    <React.Fragment>
      <Divider></Divider>
      <Box sx={{ width: '100%', overflowX: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            gap: 2,
            overflowX: 'auto',
            px: 2,
            scrollBehavior: 'smooth',
            WebkitOverflowScrolling: 'touch',
            /**
            * Opzioni scrollbar gestita per tutti i browser
            * Deve comparire solo se browser ta tablet in giù
            * si ammette lo scroll solo al touch
            */
            scrollbarWidth: isDesktop ? 'auto' : 'none',
            msOverflowStyle: isDesktop ? 'auto' : 'none',
            '&::-webkit-scrollbar': {
              height: isDesktop ? '8px' : '0px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0,0,0,0.3)',
              borderRadius: '4px',
            }
          }}
        >
          {loghi.map((logo, i) => (
            <Box
              key={`${logo.key}-${i}`}
              component="img"
              src={logo.link}
              alt={logo.key}
              sx={{
                my: 2,
                minWidth: 200,
                height: 100,
                objectFit: 'cover',
                borderRadius: 2,
                flexShrink: 0,
                cursor: 'pointer',
                transition: 'transform .2s',
                '&:hover': { transform: 'scale(1.05)' },
              }}
            />
          ))}
        </Box>
      </Box>
    </React.Fragment>
  );
}